export const SOURCE_LABELS = {
  online: "Online", whatsapp: "WhatsApp", counter: "Balcão", table: "Mesa",
  phone: "Teléfono", uber_eats: "Uber Eats", bolt_food: "Bolt Food",
};

export const SOURCE_COLORS = {
  online: "bg-blue-100 text-blue-700", whatsapp: "bg-emerald-100 text-emerald-700",
  counter: "bg-amber-100 text-amber-700", table: "bg-purple-100 text-purple-700",
  phone: "bg-cyan-100 text-cyan-700", uber_eats: "bg-lime-100 text-lime-700",
  bolt_food: "bg-orange-100 text-orange-700",
};

export const STATUS_LABELS = {
  pending: "Pendiente", preparing: "Preparando", ready: "Listo",
  delivering: "Enviando", delivered: "Entregado", cancelled: "Cancelado",
};

export const STATUS_COLORS = {
  pending: "bg-yellow-100 text-yellow-700", preparing: "bg-blue-100 text-blue-700",
  ready: "bg-teal-100 text-teal-700", delivering: "bg-purple-100 text-purple-700",
  delivered: "bg-emerald-100 text-emerald-700", cancelled: "bg-red-100 text-red-700",
};

export function formatDateShort(dateStr) {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "-"; }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "-"; }
}

export function getInitials(name) {
  if (!name) return "?";
  return name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
}
